export function getProductKey(product) {
  const first = product.otherStores && product.otherStores[0];
  return first ? `${first.id}-${first.country}-${first.retailer}` : null;
}

export function getLowestStorePrice(product) {
  if (!product || !product.otherStores || !product.otherStores.length) {
    return Infinity;
  }
  return Math.min(
    ...product.otherStores.map((s) => parseFloat(s.price.calcTotalPrice) || Infinity)
  );
}

export function findBestDealProductId(products) {
  if (!products || !products.length) {
    return null;
  }
  let bestId = null;
  let bestPrice = Infinity;
  products.forEach((product) => {
    const price = getLowestStorePrice(product);
    const key = getProductKey(product);
    if (key && price < bestPrice) {
      bestPrice = price;
      bestId = key;
    }
  });
  return bestId;
}

export function getSavingsInfo(stores, currencySign) {
  if (!stores || stores.length < 2) {
    return null;
  }
  const priced = stores
    .map((store) => ({
      store,
      price: parseFloat(store.price.calcTotalPrice) || 0,
    }))
    .filter((entry) => entry.price > 0);

  if (priced.length < 2) {
    return null;
  }

  const cheapest = priced.reduce((a, b) => (a.price < b.price ? a : b));
  const expensive = priced.reduce((a, b) => (a.price > b.price ? a : b));

  if (expensive.price <= cheapest.price) {
    return null;
  }

  const diff = (expensive.price - cheapest.price).toFixed(2);
  const sign = currencySign || '₪';
  const comparedLabel = `${expensive.store.retailer} ${expensive.store.country}`;

  return {
    diff,
    comparedLabel,
    text: `חסכון של ${sign}${diff} לעומת ${comparedLabel}`,
  };
}

export function getShippingBreakdown(store, shipToCountry, currencySign) {
  const price = store.price || {};
  const sign = currencySign || '₪';
  const product = parseFloat(price.calcPrice) || 0;
  const shipping =
    price.calcShippingPrice != null ? parseFloat(price.calcShippingPrice) : null;
  const customs =
    price.calcimportChargesPrice != null
      ? parseFloat(price.calcimportChargesPrice)
      : null;
  const total = parseFloat(price.calcTotalPrice) || 0;

  const lines = [`<b>פירוט מחיר</b>`, `מוצר: ${sign}${product.toFixed(2)}`];

  if (shipping !== null && !Number.isNaN(shipping)) {
    lines.push(`משלוח: ${sign}${shipping.toFixed(2)}`);
  } else if (store.hasShippingInfo) {
    lines.push('משלוח: כלול במחיר');
  } else {
    lines.push('משלוח: לא זמין');
  }

  if (customs !== null && !Number.isNaN(customs) && customs > 0) {
    lines.push(`מכס / מע"מ: ${sign}${customs.toFixed(2)}`);
  } else if (shipToCountry === 'IL') {
    const base = product + (shipping || 0);
    const estimated = (base * 0.17).toFixed(2);
    lines.push(`מכס משוער (17%): ~${sign}${estimated}`);
    lines.push('<small style="color:#666">*הערכה בלבד — תלוי בסוג המוצר ובסף הפטור</small>');
  }

  lines.push(`<b>סה"כ: ${sign}${total.toFixed(2)}</b>`);
  return lines.join('<br/>');
}
